// Rainmaker types matching backend implementation

export enum RainmakerEvidenceType {
  FRONT_MESSAGE = 'FRONT_MESSAGE',
  FRONT_CONVERSATION = 'FRONT_CONVERSATION',
  TRANSCRIPT = 'TRANSCRIPT',
  AUDIO_CONVERSATION = 'AUDIO_CONVERSATION',
  DOCUMENT = 'DOCUMENT',
  EMAIL = 'EMAIL',
  EMAIL_ATTACHMENT = 'EMAIL_ATTACHMENT',
  INTAKE_NOTE = 'INTAKE_NOTE',
  MESSAGE = 'MESSAGE',
  MESSAGE_ATTACHMENT = 'MESSAGE_ATTACHMENT',
  CONVERSATION = 'CONVERSATION',
  BLOB = 'BLOB',
  STAFF_NOTE = 'STAFF_NOTE',
  ARTIFACT = 'ARTIFACT',
}

export interface RainmakerEvidence {
  type: RainmakerEvidenceType;
  id: string;
  display_name?: string;
  metadata?: Record<string, unknown>;
}

export interface RainmakerAction {
  type: string;
  params: Record<string, unknown>;
  description: string;
}

export enum RainmakerSuggestionStatus {
  PENDING = 'PENDING',
  EXECUTED = 'EXECUTED',
  DISMISSED = 'DISMISSED',
}

export enum RainmakerStatus {
  ACTIVE = 'ACTIVE', // All suggestions are pending
  DONE = 'DONE', // Any suggestion has been executed
  IGNORED = 'IGNORED', // All suggestions have been dismissed
}

export interface RainmakerSuggestion {
  id: string;
  title: string;
  description?: string;
  cta_label: string;
  status: RainmakerSuggestionStatus;
  actions: RainmakerAction[];
  generator: string;
  acted_at?: string;
  evidence: RainmakerEvidence[];
}

export interface Rainmaker {
  id: string;
  task_id: string;
  status: RainmakerStatus;
  suggestions: RainmakerSuggestion[];
}
